<template>
  <div
    class="workspacebar"
    :class="{show: isSideBarVisible || isHomeSideBarShowing, eu: isEURegion}"
  >
    <div v-if="$store.state.currentUser.id">
      <WorkspaceItem
        :name="getCurrentUserName"
        :id="$store.state.currentUser.id"
        :avtMode="'personal'"
        @handle="switchToPersonalWorkspace"
        :isActive="workingMode !== 'team'"
      />
      <WorkspaceItem
        v-if="$store.state.currentAccount.id && !isEURegion"
        :name="$store.state.currentAccount.name"
        :id="$store.state.currentAccount.id"
        @handle="switchToTeamWorkspace"
        :isActive="workingMode === 'team'"
      />
      <WorkspaceNew v-if="!isEURegion" />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import WorkspaceItem from './WorkspaceItem.vue'
import WorkspaceNew from './WorkspaceNew.vue'
import config from '@/config'
import constant from '@/constant'
import Util from '@/util'

export default {
  components: {
    WorkspaceItem,
    WorkspaceNew,
  },
  props: {
    isSideBarVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTeam: 0,
    }
  },
  computed: {
    ...mapState({
      workingMode: (state) => state.workingMode,
      currentUser: (state) => state.currentUser,
      isHomeSideBarShowing: (state) => state.indicators.isHomeSideBarShowing,
    }),
    getCurrentUserName() {
      return `${this.currentUser.firstName} ${this.currentUser.lastName}`
    },
    checkAlreadyCreateTeam() {
      return window.localStorage.getItem('is-already-has-team')
    },
    isEURegion() {
      return config.region === constant.euRegion
    },
  },
  watch: {
    '$store.state.currentAccount.id': function newCAid() {
      window.localStorage.setItem('is-already-has-team', true)
    },
  },
  mounted() {
    // this.syncWorkingMode()
  },
  methods: {
    ...mapActions([
      'setCurrentAccountAction',
      'setFoldersAction',
    ]),

    switchToPersonalWorkspace() {
      this.$store.state.workingMode = constant.workspace.PERSONAL
      window.localStorage.setItem(constant.workspace.WORKING_MODE, constant.workspace.PERSONAL)
      this.$router.push({ name: 'Presentations' })
      Util.gaTrackEvent(
        constant.gaCategories.PRESENTATION_APP,
        'SideNav > Personal',
        this.$store.state.currentAccount.name,
        '',
        {
          plan: this.$store.state.currentUser.plan,
          memberCount: '',
          isSelfCreatedTeam: (this.$store.state.currentAccount.createdFrom === 'presenter'),
          teamId: this.$store.state.currentAccount.id,
          userId: this.$store.state.currentUser.id,
        },
      )
    },
    switchToTeamWorkspace() {
      this.$store.state.workingMode = constant.workspace.TEAM
      window.localStorage.setItem(constant.workspace.WORKING_MODE, constant.workspace.TEAM)
      this.$router.push({ name: 'Team' })
      Util.gaTrackEvent(
        constant.gaCategories.PRESENTATION_APP,
        'SideNav > Team',
        this.$store.state.currentAccount.name,
        '',
        {
          plan: this.$store.state.currentUser.plan,
          memberCount: '',
          isSelfCreatedTeam: (this.$store.state.currentAccount.createdFrom === 'presenter'),
          teamId: this.$store.state.currentAccount.id,
          userId: this.$store.state.currentUser.id,
        },
      )
    },
    syncWorkingMode() {
      const localWorkingMode = window.localStorage.getItem(constant.workspace.WORKING_MODE)
      if (localWorkingMode != this.workingMode) {
        this.$store.state.workingMode = localWorkingMode
      }
    },
  },
}
</script>
<style scoped>
.workspacebar {
  @apply text-sm flex flex-col text-base-0 z-20 pt-4;
  @apply fixed -left-14 top-0 bottom-0 w-14 overflow-auto;
  @apply lg:flex lg:top-15;
  background-color: #191F2D;
  transition: .15s ease;

}
.workspacebar.disabled {
  @apply hidden;
}
.workspacebar.eu {
  @apply hidden;
}
.workspacebar.show {
  @apply left-0;
}
</style>
